const PledgedProgressPercentage = ({ pledgedPercentage }) => {
  const percentage = Math.min(pledgedPercentage, 100);
  const degrees = (percentage / 100) * 360;

  return (
    <div className="pledged-progress-percentage">
      <div className="circle-progress" style={{ "--progress": `${degrees}` }}>
        <span className="number">{percentage}%</span>
      </div>
    </div>
  );
};

export default PledgedProgressPercentage;
